import { combineReducers } from 'redux';
import appReducer from './appReducer';
import mapReducer from './mapReducer';
import popUpReducer from './popUpReducer';

/**
 * This is a root reducer, It controls all reducers
 */
const rootReducer = combineReducers({
  app: appReducer,
  map: mapReducer,
  popUp: popUpReducer,
});

export default rootReducer;
